import { Button, Progress } from "reactstrap";
import Card from "@components/ui-components/card";
import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Flex from "@components/ui-components/flex";
import { useTranslation } from "react-i18next";

export const getColorByPercentage = percentage => {
    if (percentage <= 70) {
        return "success";
    } else if (percentage <= 90) {
        return "warning";
    } else {
        return "danger";
    }
};
export const Subscription = () => {
    const { t } = useTranslation();
    const usageData = [
        {
            label     : "Companies usage",
            percentage: 56,
            current   : 843,
            max       : 1500
        },
        {
            label     : "People usage",
            percentage: 26,
            current   : 5839,
            max       : 22500
        },
        {
            label     : "Users usage",
            percentage: 85,
            current   : 17,
            max       : 20,
            btnText   : "Buy seats"
        },
        {
            label     : "View only usage",
            percentage: 100,
            current   : 20,
            max       : 20
        }
    ];

    // Inactive features data
    const usageFeatures = [
        {
            label  : "Customer Portals",
            btnText: "Activate"
        },
        {
            label  : "Data Warehouse Integration",
            btnText: "Activate"
        }
    ];

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Subscriptions",
                        active: true
                    }
                ]}/>
            <Card headerClass="mt-2" header={<h2 className="text-primary">{t("Subscription Usage")}</h2>}>
                <>
                    {usageData.map((item, index) => {
                        const barColor = getColorByPercentage(item.percentage);
                        return (
                            <Card containerClass="mb-2 border rounded-0" key={index}>
                                <>
                                    <Flex
                                        justify="between"
                                        align="center"
                                        className="mb-1">
                                        <h5 className="mb-0">{t(item.label)}</h5>
                                        <Flex align="center">
                                            {item.btnText ? (
                                                <Button
                                                    outline
                                                    color="primary">
                                                    {item.btnText}
                                                </Button>
                                            ) : null}
                                            <div className={`bg-light-${barColor} border p-75 fw-bold`}>
                                                <span>
                                                    {item.percentage}% {t("Usage")}
                                                </span>
                                            </div>
                                            <div className="bg-light-secondary border p-75 fw-bold">
                                                <span className="text-black">
                                                    {item.current}
                                                /{item.max}
                                                </span>
                                            </div>
                                        </Flex>
                                    </Flex>
                                    <Progress
                                        value={item.percentage}
                                        color={barColor}
                                        animated
                                        striped/>
                                </>
                            </Card>
                        );
                    })}
                    {usageFeatures.map((feature, index) => (
                        <Card containerClass="mb-2 border rounded-0" key={index}>
                            <>
                                <Flex justify="between" align="center">
                                    <h5>
                                        {t(feature.label)}
                                    </h5>
                                    <Flex align="center">
                                        <Button outline color="primary">
                                            {feature.btnText}
                                        </Button>
                                        <Button disabled color="secondary">
                                            {t("Inactive")}
                                        </Button>
                                    </Flex>
                                </Flex>
                            </>
                        </Card>
                    ))}
                </>
            </Card>
        </>
    );
};

export default Subscription;
